<form class="form" [formGroup]="form" *ngIf="form">
  <div
    class="save-header"
    [ngClass]="{'no-tabs': isSaasEnabledProvider()}"
  >
    <h2 data-test="title-profile" data-dd-privacy="allow">About you</h2>

    <div>
      <iris-button
        (click)="onCancel()"
        [disabled]="saving || form.pristine"
        [buttonType]="irisButtonTypes.SECONDARY"
        aria-label="Cancel"
        data-test="cancel-profile-info-changes"
      >
        Cancel
      </iris-button>
      <iris-button
        (click)="saveForm()"
        [disabled]="saving || form.pristine"
        aria-label="Save"
        data-test="save-profile-info-changes"
      >
        Save
      </iris-button>
    </div>
  </div>

  <p class="iris-body-responsive">Your name and photo are the first things someone will see about you. A photo helps potential clients feel comfortable reaching out and responding to you, so make sure it's professional, inviting, and that you regularly update it. All fields are required unless marked optional.</p>

  <iris-card data-test="member-info-card" sondermindMediaQueryAttribute>
    <div class="profile-image">
      <div class="profile-img-web">
        <sondermind-profile-picture
          #profilePhotoImageWeb
          [icon]="'edit'"
          [photoUrl]="user.profilePictureId ? user.profilePictureThumbnail : null"
          (profilePictureClicked)="thumbClicked(profilePicView.WEB)"
          [initials]="userInitial"
          [reversed]="!user.profilePictureId"
          [showRequiredError]="false"
          [size]="profilePictureSize.XXX_LARGE"
          data-test="profile-picture"
        >
        </sondermind-profile-picture>
      </div>
      <div class="profile-img-mob">
        <sondermind-profile-picture
          #profilePhotoImageMob
          [icon]="'edit'"
          [photoUrl]="user.profilePictureId ? user.profilePictureThumbnail : null"
          (profilePictureClicked)="thumbClicked(profilePicView.MOBILE)"
          [initials]="userInitial"
          [reversed]="!user.profilePictureId"
          [showRequiredError]="false"
          [size]="profilePictureSize.XX_LARGE"
          data-test="profile-picture-mobile"
        >
        </sondermind-profile-picture>
      </div>
      
      <div class="tooltip-container">
        <p>View more of our&nbsp;</p>
        <sonder-tooltip class="photo-tooltip-paragraph" desktopTooltipText="Put your best face forward for potential clients
          
        • Ideally, you are the only person in the photo.
        • Use a straight-on, head and shoulders portrait that shows your whole face.
        • Choose a photo that really looks like you so potential clients aren't surprised when they meet you.
        • Use even, daytime lighting and make sure the background is not cluttered." >
          <div displayText>tips for a great photo</div>
        </sonder-tooltip>
      </div>
    </div>

    <div class="form-fields">
      <iris-form-field
        label="Preferred first name"
        helperText="Don't include a last name or titles"
        [customErrorMessages]="{
          'profanity': 'Please remove your entry and contact support&#64;sondermind.com for help',
          'validateLanguage': 'Make sure you don\'t include last names or titles'
        }"
      >
        <iris-text-input
          formControlName="preferredFirstName"
          data-test="preferred-first-name"
        >
        </iris-text-input>
        <iris-hint *ngIf="showFirstNameWarning">Make sure you don't include last names or titles</iris-hint>
      </iris-form-field>

      <div class="display-name-container">
        <p class="iris-body-bold">How your name will be displayed</p>
        <h4 class="iris-h4-responsive">{{user.displayName}}</h4>
      </div>

      <iris-form-field
        label="Professional phone number"
      >
        <iris-text-input
          type="tel"
          formControlName="publicPhoneNumber"
          [mask]="maskingService.ngxMaskPhoneNumber"
          data-test="public-phone-number"
        >
        </iris-text-input>
      </iris-form-field>

      <iris-form-field
        label="Pronouns"
      >
        <iris-dropdown
          formControlName="pronouns"
          [options]="pronounList"
          data-test="pronouns">
        </iris-dropdown>
      </iris-form-field>
    </div>

  </iris-card>
</form>